import type { IntlService } from 'ember-intl'
import type { MathseedsPrimeThread } from 'teacher-ui-client/progression-sequence/utils'

export default function (intl: IntlService, thread: MathseedsPrimeThread, unit: number, lesson: number): string {
  const threadCode = intl.t(`mathseedsPrimeThreads.${thread}.code`)
  return `${threadCode}.${unit}.${lesson}`
}
